<template>
  <div class="popupbox">
    <div class="logo">
      <img src="@/assets/image/logo.png" :alt="$t('layout.logo.alt')">
    </div>
    <h3>{{ $t('pwChangeForm.title') }}</h3>
    <div class="PWrule">
      <ul :key="'rule-'+ruleIndex" v-for="(ruleItem, ruleIndex) in $t('pwChangeForm.rule')">
        [ {{ $t(`pwChangeForm.rule[${ruleIndex}].title`)}} ]<br>
        <i18n
          :key="'li-'+liIndex" v-for="(item, liIndex) in ruleItem.li"
          :path="`pwChangeForm.rule[${ruleIndex}].li[${liIndex}].txt`" tag="li">
          <span>{{ $t(`pwChangeForm.rule[${ruleIndex}].li[${liIndex}].accent`) }}</span>
        </i18n>
      </ul>
    </div>
    <input
      type="password"
      :placeholder="$t('pwChangeForm.inputNewPw.ph')"
      :aria-label="$t('pwChangeForm.inputNewPw.label')"
      @keyup="checkCapsLock($event, 0)"
      v-model="pw"
    />
    <p class="validation" v-if="isCapsLock && inputFocus == 0">
      {{ $t('loginForm.message.onCapsLock') }}
    </p>
    <p class="validation" v-show="validPwMessageInfo && !validPwMessageInfo.isValid">
      {{$t(
        `pwChangeForm.message.valid.${validPwMessageInfo.resultCode||'temp'}`,
        [validPwMessageInfo.target]
      )}}
    </p>
    <input
      type="password"
      :placeholder="$t('pwChangeForm.inputConfirmPw.ph')"
      :aria-label="$t('pwChangeForm.inputConfirmPw.label')"
      class="pwconfirm"
      @keyup="checkCapsLock($event, 1)"
      v-model="confirmPw"
    />
    <p class="validation" v-if="isCapsLock && inputFocus == 1">
      {{ $t('loginForm.message.onCapsLock') }}
    </p>
    <p class="validation" v-show="!isSamePassword">
      {{ $t('pwChangeForm.message.valid.comp') }}
    </p>
    <button class="btnChange"
      :disabled="!canSubmit"
      @click="pwChangeProcess"
    >
      {{ $t('pwChangeForm.btnChange') }}
    </button>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { changePw } from '@/api/auth';
import { checkPwValid } from '@/utils/pwValidator';

export default {
  name: 'PwChangeForm',
  components: {
  },
  props: {
  },
  data:() => ({
    pw: '',
    confirmPw: '',
    isCapsLock: false,
    inputFocus: -1,
  }),
  methods: {
    pwChangeProcess(){
      if(!this.canSubmit) return;
      this.popWait();
      changePw(this.pw)
      .finally(() => {
        this.stopWait();
      })
      .then((e) =>{
        if(e.status === 200){
          if(e.data.resultCode==="0000"){
            this.popAlert('pwChangeForm.message.success');
            this.$emit('success');
            return Promise.resolve();
          } else {
            this.popAlert({
              text: (e.data.resultMessage).replace(/\\n/g, '\n'),
            });
          }
        }else{
          return Promise.reject('-1');
        }
      })
      .catch(() => {
        this.popAlert('pwChangeForm.message.defaultErr');
      })
    },
    checkCapsLock(evt, target){
      this.isCapsLock = evt.getModifierState('CapsLock');
      this.inputFocus = target;
    },
    ...mapActions([
      'popAlert',
      'popWait',
      'stopWait',
    ]),
  },
  computed: {
    validPwMessageInfo(){
      if(this.pw === '') return {
        isValid: true
      };
      return checkPwValid(this.pw);
    },
    isSamePassword(){
      return this.pw === this.confirmPw;
    },
    canSubmit(){
      return this.pw !== ''
        && this.validPwMessageInfo
        && this.validPwMessageInfo.isValid
        && this.isSamePassword;
    },
  },
};
</script>
<style lang="scss" scoped>
  .popupbox{
    display: flex;
    flex-direction: column;
    padding: 20px;
  }

  .logo {
    width: 120px;
    height: 50px;
    margin: 0 auto;
    margin-top: 10px;
  }
  h3 {
    text-align: center;
    margin-top: 10px;
    border-top: 1px solid #ddd;
    padding-top: 10px;
    color: #555;
  }
  .PWrule {
    height: auto;
    border: 1px solid #ddd;
    margin-top: 20px;
    margin-bottom: 20px;
    border-left: 4px solid #0083bf;
    > ul {
      font-size: 14px;
      color: #103165;
      margin: 10px 0 10px 10px;
      > li {
        font-size: 12px;
        color: #999;
        margin-left: 10px;
        > span {
          color: #e02f2f;
          font-weight: 500;
        }
      }
    }
  }
  input {
    display: block;
    height: 40px;
    margin-top: 10px;
    border: 1px solid #ddd;
    padding: 0 10px 0 40px;
    background-image: url('~@/assets/image/pwChange.png');
    background-repeat: no-repeat;
    &.pwconfirm {
      background-image: url('~@/assets/image/pwconfirm.png');
    }
    &::placeholder {
      font-size: 12px;
      color: #999;
    }
    &:focus {
      outline: 1px solid #798796;
      &::placeholder {
        color: transparent;
      }
    }
  }
  .btnChange {
    display: block;
    height: 40px;
    background-color: #0059a9;
    text-align: center;
    line-height: 40px;
    color: #fff;
    margin-top: 30px;
    transition: 0.3s;
    font-size: 12pt;
    border: 0px none;
    cursor: pointer;
    &:hover {
      background-color: #004788;
    }
    &:disabled{
      background-color: #eee;
      color: #555;
    }
  }
  .validation{
    color: #ff0000;
    font-size: 12px;
    &::before {
      content: '*'
    }
  }
</style>
